import * as React from 'react'

function BoyNoContent() {
  return (
    <svg
      width={200}
      height={258}
      viewBox="0 0 200 258"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 258c55.228 0 100-6.492 100-14.5S155.228 229 100 229 0 235.492 0 243.5 44.772 258 100 258z"
        fill="#F3F5F8"
      />
      <path
        d="M113.58 75.564c1.217.553 4.093 2.762 5.198 4.035 1.273-.609 23.054-14.207 26.207-14.043 3.154.165 1.493 6.411 1.493 7.02 0 .608-26.273 21.065-30.554 21.065-4.28 0-9.972-9.288-9.972-9.84 0-.553 7.628-8.237 7.628-8.237zM84.065 234.186h7.97v4.803h-7.97v-4.803zM68.593 234.131h7.97v4.803h-7.97v-4.803z"
        fill="#B3B3B3"
      />
      <path
        d="M95.073 65.855c4.15-6.405 20.385 6.872 20.819 9.653.434 2.782-6.208 13.733-11.426 13.457-5.217-.276-11.81-19.382-9.393-23.11z"
        fill="#605F5F"
      />
      <path
        d="M79.078 126.023l4.287 109.212h9.104l12.563-103.51"
        fill="#F2034B"
      />
      <path
        d="M63.605 125.971l4.288 109.211h9.104l12.563-103.51"
        fill="#FF7690"
      />
      <path
        d="M83.762 237.781v7.132h20.908v-2.345l-11.883-4.787h-9.025z"
        fill="#000"
      />
      <path
        d="M68.29 237.727v7.131h20.907v-2.344l-11.882-4.787H68.29z"
        fill="#000"
      />
      <path
        d="M85.563 55.871c-31.642 0-23.127 64.928-22.643 70.152 2.42 4.16 40.841 8.726 43.156 6.195.966-7.26 9.387-76.347-20.513-76.347z"
        fill="#4D4D4D"
      />
      <path
        d="M80.925 59.063c0 1.835 10.16 2.226 10.16 0V46.586h-10.16v12.477z"
        fill="#9C9B9B"
      />
      <path
        d="M92.397 51.987c4.674-1.86 6.438-8.46 3.938-14.742-2.499-6.281-8.314-9.866-12.988-8.007-4.675 1.86-6.438 8.46-3.939 14.742 2.5 6.282 8.315 9.867 12.99 8.007z"
        fill="#B3B3B3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.047 42.525a.326.326 0 01.468.079c.037.053.083.113.139.186l.003.004c.055.072.118.155.18.244.123.175.256.392.329.641.076.258.087.55-.034.853-.118.296-.349.569-.696.823a.327.327 0 01-.467-.086.36.36 0 01.082-.487c.281-.206.408-.384.462-.52a.554.554 0 00.012-.378 1.547 1.547 0 00-.229-.433 6.448 6.448 0 00-.163-.22l-.008-.01a5.508 5.508 0 01-.153-.207.36.36 0 01.075-.489zM87.378 50.07c.167.244.5.306.743.139.176-.121.524-.297.915-.357.38-.058.76-.004 1.09.269a.535.535 0 10.682-.825c-.627-.518-1.343-.592-1.934-.5-.58.088-1.077.338-1.358.531a.535.535 0 00-.138.744z"
        fill="#1F161E"
      />
      <ellipse cx={84.77} cy={39.583} rx={0.535} ry={1.07} fill="#0D0D0D" />
      <ellipse cx={93.647} cy={39.253} rx={0.535} ry={1.07} fill="#0D0D0D" />
      <path
        d="M83.825 43.774c1 0 1.809-.294 1.809-.657 0-.364-.81-.658-1.809-.658-.998 0-1.808.294-1.808.657 0 .364.81.658 1.808.658zM95.004 43.774c.999 0 1.808-.294 1.808-.657 0-.364-.81-.658-1.808-.658-.999 0-1.808.294-1.808.657 0 .364.81.658 1.808.658z"
        fill="#FA9E9F"
      />
      <path
        d="M81.123 47.972c.915-.655.896-2.25-.043-3.56-.939-1.311-2.442-1.842-3.357-1.187-.915.656-.896 2.25.043 3.56.938 1.312 2.442 1.843 3.357 1.187z"
        fill="#B3B3B3"
      />
      <path
        d="M70.881 39.746c0-1.696 1.582-3.56 1.88-5.69.155-1.08-.18-5.57 1.08-7.09 2.63-3.146 4.162-2.501 6.164-3.235 3.488-1.275 4.823-3.39 7.703-3.39 3.288 0 4.603 1.697 6.934 1.697 2.677 0 4.873-1.233 8.631-1.233 2.002 0 4.619 2.63 4.619 4.932 0 5.465-5.083 4.682-5.083 6.01 0 .924.309 1.644.309 2.93 0 1.644-2.157 2.63-3.39 2.63-3.754 0-4.254-.457-4.254-.457a17.609 17.609 0 00-2.828-4.09c-.15-.158-2.59 1.565-6.575 1.7-3.265.108-5.566.74-5.566 2.258 0 1.076.394 4.275.371 5.162-.023.888-.329 1.48-.542 1.48-.214 0-.33-.29-1.569-.29-1.344 0-1.45 1.644-1.68 1.644-1.348-.01-6.204-1.104-6.204-4.968z"
        fill="#1F161E"
      />
      <path
        d="M57.192 80.662c-.2 1.5-4.125 19.37-3.131 27.357.993 7.986 4.694 16.017 5.85 20.07 1.482 5.25 1.434 12.505 3.211 15.336.954 1.519 4.215 2.783 5.48 1.989 1.263-.794 4.327-3.008 2.14-8.043-3.41-7.858-5.919-22.231-5.49-25.812.429-3.581 5.658-29.641 5.577-31.21-.082-1.57-12.992-4.606-13.637.313z"
        fill="#B3B3B3"
      />
      <path
        d="M71.59 62.849c7.556 2.142 3.895 23.467 1.684 24.855-2.21 1.389-14.937-1.79-17.223-7.292-2.286-5.502 11.127-18.808 15.538-17.563z"
        fill="#605F5F"
      />
      <path
        d="M158.13 21.838l-3.235-.46-6.576-.93-.93 6.575-27.618 195.165-1.716 12.126a6.634 6.634 0 005.638 7.496l3.239.46a6.632 6.632 0 007.496-5.642l1.716-12.122 27.618-195.165.931-6.576-6.563-.927z"
        fill="#DFDFDF"
      />
      <path
        d="M159.57 0l-11.244 20.447 16.373 2.318L159.57 0z"
        fill="#B3B3B3"
      />
      <path d="M161.26 7.503L159.57 0l-3.705 6.737 5.395.766z" fill="#4D4D4D" />
      <path
        d="M136.399 222.549l-16.375-2.319-.832 5.88 16.374 2.318.833-5.879z"
        fill="#B3B3B3"
      />
    </svg>
  )
}

export default React.memo(BoyNoContent)
